import { Box, Grid, Typography } from "@mui/material"
import { HiLockClosed } from "react-icons/hi2";

export const TarjaSecurity = () => {
    return (
        <Box sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px"
        }}>
            <Grid>
                <HiLockClosed color="#87869D" />
            </Grid>
            <Typography color={"#87869D"} fontStyle={"italic"} fontSize={"12px"} textAlign={"justify"}>Todos os dados são criptografados, em conformidade com a Lei Geral de Proteção de Dados - LGPD (Lei nº 13.709/2018)</Typography>
        </Box>
    )
}